import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoFaqWithImg from 'eco-design/sections/eco-faq-win-img';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

type ImgsType = {
    [key: string]: string[];
};

export default function Comp() {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.FaqA');

    const imgsMap: ImgsType = {
        us: [
            'https://websiteoss.ecoflow.com/upload/image/1746517248187/faqA_bg1.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1746517250659/faqA_bg2.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1746517255820/faqA_bg3.jpg',
        ],
    };

    const imgs = imgsMap[locale];

    const itemsA = [
        {
            pc: imgs[0],
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: imgs[1],
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: imgs[2],
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
    ];

    return (
        <div className={styled.FaqA}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <EcoFaqWithImg
                items={itemsA}
                dataLayerTab={{
                    event: 'uaEvent',
                    event_name: 'product_detail_page',
                    list_name: t('title'),
                }}
            />
            <EcoSpace />
        </div>
    );
}
